import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Button, Form } from "react-bootstrap";
import createCustomSchema from "../../fieldValidator/fieldValidator";
import { calculateResignationDates } from "../../utils/calculateResignationDates";
import { employeeDetails } from "../../auth";
import api from "../../api/axios";
import Swal from "sweetalert2";
import { terminateEmployee } from "../../services/ResignationServices";
import Loader from "../Loader";

const DeactivateCompany = ({ show, handleClose, selectedCompany  , deleteCompany ,
  Name = "Delete",
  btnName = "Delete",
  deactivateLoading}) => {


  return (
    <Modal
          show={show}
          onHide={handleClose}
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div className="form-header text-center">
              <h3>{Name}</h3>
              <p>Are you sure you want to  {selectedCompany?.status == 0 ? "Activate" : "Deactivate"} -{selectedCompany?.company_name}</p>
            </div>
            <div className="d-flex justify-content-between mt-4 gap-4">
              <Button variant="danger" onClick={(e)=>deleteCompany(e, selectedCompany?.id , selectedCompany?.status == 1 ? 0 : 1 )} className="w-100" disabled={deactivateLoading? true : false}>
                {btnName}
              </Button>
              <Button variant="secondary" onClick={handleClose} className="w-100" disabled={deactivateLoading? true : false}>
                Cancel
              </Button>
            </div>
          </Modal.Body>
        </Modal>
  );
};

export default DeactivateCompany;
